// extracted by mini-css-extract-plugin
export default {"statusesItem":"approval-status-item_statusesItem__mR9Xx","statusText":"approval-status-item_statusText__IBGCf"};